import axios from "axios";
import {Base_URL} from "../url"

export const fetchReportingWbsData = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ReportingWbs/ReportingWbsGetData`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching Reporting WBS data!";
  }
};

export const downloadReportingWbsExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/ReportingWbs/DownloadReportingWbsExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob', // Important for file downloads
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading Reporting WBS data!";
  }
};